import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checked",
  "use": "icon-checked-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-checked\">\n  <path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M18.53 7.465c.53.53.53 1.39 0 1.921l-7.044 7.045c-.52.52-1.357.53-1.89.03a1.43 1.43 0 0 1-.21-.172l-3.842-3.843a1.358 1.358 0 0 1 1.921-1.921l3.042 3.041 6.102-6.101c.53-.53 1.39-.53 1.921 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol